import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import SvgUser from "components/svg/SvgUser";
import SvgCheckSquare from "components/svg/SvgCheckSquare";
import EToolTip from "components/others/EToolTip";
import { useObjectCard } from "./context/ObjectCardProvider";
import vconst from "utils/helpers/structs/vconst";
import useStatusObject from "./hooks/hookStatusObject";
import { useNavigate } from "react-router-dom";
import useSettingsParams from "hooks/useSettingsParams";
import { useSettings } from "context/SettingsContext";
import { useToast } from "context/ToastContext";
import * as apiObject from "api/apiObjects";
import { useState } from "react";
import SolarIcon from 'components/icons/SolarIcon';

const ObjectCardToolBar = ({setClientInfoId, handleChangeStatus, onShowTasks}) => {

    const { t } = useTranslation(['Objects', 'Clients', 'Leads', 'common']);
    const { vObject, showSpinner, showAnalytics, setShowAnalytics, fetchObject, onlySale, onlyService, isSaleLike } = useObjectCard();
    const { statusObjectFinished, statusObjectReject, statusObjectReturnToTeam } = useStatusObject();
    const objectStatus = vObject?.object?.objectStatus;
    const canCancelObject = isSaleLike
        ? objectStatus === vconst.objectInWork
        : [vconst.objectPanding, vconst.objectInWork].includes(objectStatus);
    const canFinishObject = isSaleLike
        ? objectStatus === vconst.objectInWork
        : [vconst.objectPanding, vconst.objectInWork, vconst.objectFinishedTeam].includes(objectStatus);
    const canReturnToTeam = !isSaleLike && objectStatus === vconst.objectFinishedTeam;
    const  navigate = useNavigate();
    const params = useSettingsParams();
    const { localSettings, getSettings } = useSettings();
    const { showToast } = useToast();
    const canShowTasks = params.tasksModule && params.tasksForObjects;
    const [ reservBusy, setReservBusy ] = useState(false);
    const objectId = vObject?.object?.ID;
    const leadId = Number(vObject?.lead?.ID || vObject?.object?.leadId || 0) || 0;
    const clientId = Number(vObject?.object?.clientId || 0) || 0;

    const reservWarehouseId = vObject?.reservWarehouseId
        || localSettings?.WAREHOUSES?.find((w) => Number(w.reservObjectId) === Number(objectId))?.ID
        || null;

    const handleReservWarehouse = async () => {
        if (reservBusy || showSpinner) return;
        if (reservWarehouseId) {
            navigate(`/warehouse/${reservWarehouseId}`);
            return;
        }
        if (!objectId) return;

        setReservBusy(true);
        try {
            const warehouseId = await apiObject.createReservWarehouse(objectId);
            if (!warehouseId) {
                showToast(t('common:messError'), 'danger');
                return;
            }
            await getSettings();
            await fetchObject?.();
            navigate(`/warehouse/${warehouseId}`);
        } finally {
            setReservBusy(false);
        }
    };

    return (
        <div className="mb-3" style={{minWidth:'100px'}}>
            <div className="page-toolbar-actions">
                 
                {/*[vconst.objectFinished, vconst.objectReject].includes(vObject?.object?.objectStatus) && 
                    (<Button
                        className="ms-1"
                        variant="info"
                        size="sm"
                        disabled={showSpinner}
                        onClick={()=>statusObjectOpen(handleChangeStatus)}>
                        <SolarIcon name="sunrise" className="fs-14 me-1" />
                        {t('toolObjectOpen')}
                    </Button>)*/}

                {canFinishObject && 
                    (<Button
                        className="ms-1"
                        variant="success"
                        size="sm"
                        disabled={showSpinner}
                        onClick={()=>statusObjectFinished(handleChangeStatus, vObject?.object?.objectPower)}>
                        <SolarIcon name="sun-fill" className="fs-14 me-1" />
                        {onlyService ? t('toolServiceSaleFinished') : onlySale ? t('toolSaleFinished') : t('toolObjectFinished')}
                    </Button>)}

                {leadId ? (
                <EToolTip title={t('toolShowLead')}>
                    <span className="d-inline-block ms-1">
                        <Button
                            className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                            variant="success"
                            size="sm"
                            disabled={showSpinner}
                            onClick={(e)=>{
                                e.currentTarget.blur();
                                navigate(`/leads/${leadId}`);
                            }}
                        >
                            <SolarIcon name="card-checklist" className="fs-14" />
                        </Button>
                    </span>
                </EToolTip>
                ) : null}

                {canShowTasks && (
                <EToolTip title={t('toolTask')}>
                    <span className="d-inline-block ms-1">
                        <Button
                            className="toolbar-label-btn"
                            size="sm"
                            disabled={showSpinner}
                            onClick={(e) => {
                                e.currentTarget.blur();
                                onShowTasks?.();
                            }}
                        >
                            <SvgCheckSquare width={14} height={14} />
                            <span className="d-none d-md-inline ms-1">{t('toolTask')}</span>
                        </Button>
                    </span>
                </EToolTip>
                )}

                {!onlyService ? (
                <EToolTip title={reservWarehouseId ? t('toolOpenReservWarehouse') : t('toolCreateReservWarehouse')}>
                    <span className="d-inline-block ms-1">
                        <Button
                            className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                            variant={reservWarehouseId ? 'info' : 'secondary'}
                            size="sm"
                            disabled={showSpinner || reservBusy}
                            onClick={(e)=>{
                                e.currentTarget.blur();
                                handleReservWarehouse();
                            }}
                        >
                            {reservBusy
                                ? <span className="spinner-border spinner-border-sm" role="status" />
                                : <SolarIcon name="box-seam" className="fs-14" />}
                        </Button>
                    </span>
                </EToolTip>
                ) : null}

                <EToolTip title={showAnalytics ? t('toolHideAnalytics') : t('toolShowAnalytics')}>
                    <span className="d-inline-block ms-1">
                        <Button
                            className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                            size="sm"
                            variant={showAnalytics ? 'info' : 'secondary'}
                            disabled={showSpinner}
                            onClick={(e) => {
                                e.currentTarget.blur();
                                setShowAnalytics((prev) => !prev);
                            }}
                        >
                            <SolarIcon name="graph-up-arrow" className="fs-14 p-0" />
                        </Button>
                    </span>
                </EToolTip>

                <EToolTip title={t('common:toolRefreshList')}>
                    <span className="d-inline-block ms-1">
                        <Button
                            className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                            size="sm"
                            disabled={showSpinner}
                            onClick={(e) => {
                                e.currentTarget.blur();
                                void fetchObject?.();
                            }}
                        >
                            <SolarIcon name="arrow-clockwise" className="fs-14" />
                        </Button>
                    </span>
                </EToolTip>

                {canCancelObject && (
                    <EToolTip title={onlyService ? t('toolServiceSaleCancel') : onlySale ? t('toolSaleCancel') : t('toolObjectCancel')}>
                        <span className="d-inline-block ms-1">
                            <Button
                                className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                                variant="danger"
                                size="sm"
                                disabled={showSpinner}
                                onClick={(e)=>{
                                    e.currentTarget.blur();
                                    statusObjectReject(handleChangeStatus);
                                }}
                            >
                                <SolarIcon name="x-circle" className="fs-14" />
                            </Button>
                        </span>
                    </EToolTip>
                )}

                {canReturnToTeam && (
                    <EToolTip title={t('toolObjectReturnToTeam')}>
                        <span className="d-inline-block ms-1">
                            <Button
                                className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                                variant="warning"
                                size="sm"
                                disabled={showSpinner}
                                onClick={(e)=>{
                                    e.currentTarget.blur();
                                    statusObjectReturnToTeam(handleChangeStatus);
                                }}
                            >
                                <SolarIcon name="arrow-return-left" className="fs-14" />
                            </Button>
                        </span>
                    </EToolTip>
                )}

                {clientId ? (
                <EToolTip title={t('Leads:leadPopup.client')}>
                    <span className="d-inline-block ms-1">
                        <Button
                            className="fs-14 px-2 toolbar-icon-btn d-inline-flex align-items-center justify-content-center"
                            size="sm"
                            onClick={(e)=>{
                                e.currentTarget.blur();
                                setClientInfoId(clientId);
                            }}
                        >
                            <SvgUser width={14} height={14} />
                        </Button>
                    </span>
                </EToolTip>
                ) : null}
                
            </div>
        </div>
    )
}

export default ObjectCardToolBar;
